import {
  SiFlutter,
  SiJavascript,
  SiReact,
  SiCss,
  SiTailwindcss,
  SiHtml5,
  SiAndroidstudio,
  SiFigma,
  SiGit,
  SiDocker,
  SiLinux,
} from "react-icons/si";
import { DiPhotoshop } from "react-icons/di";
import { DiJava } from "react-icons/di";

import hacknite from "../assets/Cetificates_src/hacknite.png"
import nss from "../assets/Cetificates_src/nss.png"
import iedc from "../assets/Cetificates_src/iedc_summit_23.png"
import gen_ai from "../assets/Cetificates_src/gen_ai_wrokshop.png"
import kiw from "../assets/Cetificates_src/kiw_volunteer.png"
import flutter from "../assets/Cetificates_src/flutter_intership.png"
import design from "../assets/Cetificates_src/design_a_thon_kiw.png"

import churn_mock from "../assets/images/mock/churn_mock.webp"
import ticket_mock from "../assets/images/mock/ticket_mock.webp"
import malprober_mock from "../assets/images/mock/malprober_mock.webp"
import lab_exam_mock from "../assets/images/mock/lab_exam_mock.webp"

export const mockMap = {
  "lab-exam-portal" : lab_exam_mock,
  "churn-predictor" : churn_mock,
  "ticket-triage" : ticket_mock,
  "malprober" : malprober_mock
}



// Add more anytime — panel auto-adjusts (scatter + marquee both read from array length).
export const techStack = [
  { id: "flutter", name: "Flutter", Icon: SiFlutter },
  { id: "javascript", name: "JavaScript", Icon: SiJavascript },
  { id: "react", name: "React", Icon: SiReact },
  { id: "java", name: "Java", Icon: DiJava },
  { id: "css", name: "CSS", Icon: SiCss },
  { id: "tailwind", name: "Tailwind CSS", Icon: SiTailwindcss },
  { id: "html", name: "HTML", Icon: SiHtml5 },
];

export const toolStack = [
  { id: "android-studio", name: "Android Studio", Icon: SiAndroidstudio },
  { id: "figma", name: "Figma", Icon: SiFigma },
  { id: "photoshop", name: "Photoshop", Icon: DiPhotoshop },
  { id: "git", name: "Git", Icon: SiGit },
  { id: "docker", name: "Docker", Icon: SiDocker },
  { id: "linux", name: "Linux", Icon: SiLinux },
];

// Replace with real certs — id, title, image only (per your call).
export const certificates = [
  { id: 1, title: "hacknite [hack-a-thon]", image: hacknite},
  { id: 2, title: "hack sphere [hack-a-thon]", image: nss },
  { id: 3, title: "IEDC. summit 2023", image: iedc },
  { id: 4, title: "gen ai workshop", image: gen_ai },
  { id: 5, title: "flutter intership", image: flutter },
  { id: 6, title: "KIW volunteer", image: kiw },
  { id: 7, title: "design-a-thon", image: design },
];

export const EXP = [
  {
  title: "Coding",
  desc: "I enjoy building things with Flutter, React, Python, FastAPI and AI/ML. Most of my experience comes from college projects, personal projects and hackathons, where I get to explore new technologies and turn ideas into working products.",
},
  {
  title: "Graphic Design",
  desc: (
    <>
      I gained professional experience during my internship at{" "}
      <a
        href="https://www.playspots.in/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-green-700 hover:underline"
      >
        PlaySpots
      </a>
      , working on graphics and visual content for different digital and marketing needs.
    </>
  ),
},
  {
    title: "UI/UX Design",
    desc: "I’ve designed interfaces for college and personal projects, with a focus on keeping them simple, practical and easy to use. Figma is my go-to for bringing ideas to life.",
  },
  {
    title: "Leadership",
    desc: "Through IEDC, muLearn and other communities, I’ve had the chance to work with teams, take responsibility and help bring ideas and events together.",
  },
  {
    title: "Photography",
    desc: "Photography has been a hobby of mine for years, along with previous freelance experience. I enjoy capturing portraits, events and everyday moments.",
  },
];